import moment from 'moment';
import * as React from 'react';
import ClassNames from 'classnames';
import { connect } from 'react-redux';
import * as StM from '../../../models/store';
import * as SrvM from '../../../services';

interface ICourtSelectorProps {
    courts: Array<StM.ICourtStoreState>;
    date?: moment.Moment;
}

interface ICourtSelectorState {
}

class CourtSelector extends React.Component<ICourtSelectorProps, ICourtSelectorState> {
    private courtTimeService = new SrvM.CourtTimeService();

    constructor(props: ICourtSelectorProps) {
        super(props);
    }

    render() {
        const courts = this.props.date
            ? this.courtTimeService.getAvailableCourts(this.props.courts, this.props.date)
            : this.props.courts;

        return (
            <div className="table-header-wrapper">
                <div className="left-arrow"></div>
                {courts.map((court)=> { return (
                    <div key={court.id} className='court-tooltip-container'>
                        <div className={ClassNames('table-header-item', { 'admin-only-court': court.isAdminOnly })}>
                            {StM.Strings.CourtPrefix} {court.title}
                        </div>
                        <div className={ClassNames('court-tooltip', { 'admin-only-court': court.isAdminOnly })}>
                            <span className="court-tooltip-title">{StM.Strings.CourtPrefix} {court.title}</span>
                            {court.isAdminOnly && <span className="court-tooltip-note">Not available for online booking</span>}
                        </div>
                    </div>
                )})}
                <div className="right-arrow"></div>
            </div>
        )
    };
};

function mapStateToProps(state: StM.IGlobalStoreState) {
    return { courts: state.club.courts  }
}

function mapDispatchToProps(dispatch: any) {
    return {    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CourtSelector);
